// removed by extract-text-webpack-plugin
module.exports = {"modal-body":"app-components-receipt-refunds-TransactionRefundModal-__TransactionRefundModal___JUMGu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/TransactionRefundModal/TransactionRefundModal.css
// module id = 2019
// module chunks = 0